import { motion } from "framer-motion";
import { BookUser, Camera, Landmark, GraduationCap, Briefcase, Plane, MailOpen, Files, Info } from "lucide-react";
import { DOC_CHECKLIST } from "../data/content";
import { SectionHeading, stagger, fadeUp, Reveal } from "../lib/motion";
import { t } from "../i18n";

const ICONS = { BookUser, Camera, Landmark, GraduationCap, Briefcase, Plane, MailOpen, Files };

const DocChecklist = () => (
  <section id="documents" data-testid="document-checklist-section" className="relative py-24 lg:py-32 bg-[#F7F6F2]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        light
        eyebrow={t("docs.eyebrow")}
        title={t("docs.title")}
        description={t("docs.desc")}
        testid="documents-heading"
      />
      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-60px" }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5"
      >
        {DOC_CHECKLIST.map((d, i) => {
          const Icon = ICONS[d.icon];
          return (
            <motion.div
              key={d.title}
              variants={fadeUp}
              data-testid={`doc-card-${i}`}
              className="group bg-white rounded-xl p-6 border border-slate-200/80 transition-all duration-400 hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(11,19,43,0.25)] hover:border-gold/60"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-navy text-gold mb-5 transition-transform duration-500 group-hover:scale-110">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="font-display text-base font-bold text-navy mb-2 tracking-tight">{t(`docs.items.${i}.title`, d.title)}</h3>
              <p className="text-[13px] text-slate-600 leading-relaxed">{t(`docs.items.${i}.text`, d.text)}</p>
            </motion.div>
          );
        })}
      </motion.div>
      <Reveal className="mt-10">
        <p className="flex items-center justify-center gap-2 text-center text-xs text-slate-500" data-testid="documents-note">
          <Info className="h-4 w-4 text-gold-dark shrink-0" />
          {t("docs.note")}
        </p>
      </Reveal>
    </div>
  </section>
);

export default DocChecklist;
